import { inject, injectable } from 'inversify';
import WalletService from 'src/features/pariWallet/data/service/WalletService';
import { GetWalletParams } from 'src/features/pariWallet/data/service/WalletService.types';
import { GetWalletUseCaseInterface } from 'src/features/pariWallet/domain/WalletUseCases.types';

@injectable()
class GetWalletUseCase implements GetWalletUseCaseInterface {
  @inject(WalletService) private walletService!: WalletService;

  async execute({ userUuid }: GetWalletParams) {
    const response = await this.walletService.getWallet({ userUuid });

    return {
      ...response.data,
      amount_available:
        Number(response.data.amount_available) >= 0
          ? response.data.amount_available
          : '0',
    };
  }
}

export default GetWalletUseCase;
